// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__EiUfp","icon":"styles_icon__9Doz4","title":"styles_title__7cNW-","description":"styles_description__wxHeW"};